/* ==========================================================================
   Nutrubabe — global UI behaviour
   Loaded once from the header group.

   Three jobs:
     1. Sticky header that shrinks and lifts on scroll
     2. Scroll-triggered reveal, applied at SECTION level only
     3. Add-to-cart that confirms in place instead of jumping the page

   Everything here degrades safely: if JS fails, content is visible and forms
   submit normally.
   ========================================================================== */

(function () {
  'use strict';

  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* --- 1. header ---------------------------------------------------------- */

  function initHeader() {
    var root = document.documentElement;
    var ticking = false;

    function update() {
      root.classList.toggle('nb-scrolled', window.scrollY > 40);
      ticking = false;
    }

    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    }, { passive: true });

    update();
  }

  /* --- 2. scroll reveal ---------------------------------------------------
     Sections opt in with .nb-reveal. Deliberately coarse-grained: revealing
     every individual element is the thing that reads as amateurish. */

  function initReveal() {
    var targets = document.querySelectorAll('.nb-reveal:not(.is-in)');
    if (!targets.length) return;

    if (reduced || !('IntersectionObserver' in window)) {
      targets.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-in');
        io.unobserve(entry.target);              // reveal once, never re-hide
      });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.05 });

    targets.forEach(function (el) {
      // Anything already on screen at load shows immediately — no flash of
      // empty content on first paint.
      if (el.getBoundingClientRect().top < window.innerHeight * 0.9) {
        el.classList.add('is-in');
      } else {
        io.observe(el);
      }
    });
  }

  /* --- 3. add to cart ----------------------------------------------------- */

  function cartAddUrl() {
    return (window.routes && window.routes.cart_add_url) || '/cart/add';
  }

  function refreshCartCount() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) {
        if (!cart) return;
        document.querySelectorAll('.cart-count-bubble span[aria-hidden="true"]').forEach(function (n) {
          n.textContent = cart.item_count;
        });
        // Dawn omits the bubble entirely when the cart is empty; create it
        // once there's something in it.
        var icon = document.querySelector('#cart-icon-bubble');
        if (icon && cart.item_count > 0 && !icon.querySelector('.cart-count-bubble')) {
          var b = document.createElement('div');
          b.className = 'cart-count-bubble';
          b.innerHTML = '<span aria-hidden="true">' + cart.item_count + '</span>';
          icon.appendChild(b);
        }
      })
      .catch(function () { /* count is cosmetic — never block on it */ });
  }

  function initAddToCart() {
    document.querySelectorAll('form.nb-atc-form').forEach(function (form) {
      if (form.dataset.nbBound === '1') return;
      form.dataset.nbBound = '1';

      form.addEventListener('submit', function (e) {
        var btn = form.querySelector('[name="add"]');
        if (!btn) return;                        // no button: let it submit normally

        e.preventDefault();
        if (btn.classList.contains('is-busy') || btn.classList.contains('is-added')) return;

        var original = btn.textContent.trim();
        btn.classList.add('is-busy');
        btn.disabled = true;

        fetch(cartAddUrl() + '.js', {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: new FormData(form)
        })
          .then(function (res) {
            if (!res.ok) throw new Error('add failed');
            return res.json();
          })
          .then(function () {
            btn.classList.remove('is-busy');
            btn.classList.add('is-added');
            btn.textContent = 'Added';
            refreshCartCount();

            window.setTimeout(function () {
              btn.classList.remove('is-added');
              btn.textContent = original;
              btn.disabled = false;
            }, 2000);
          })
          .catch(function () {
            // Anything unexpected: fall back to a normal form post so the
            // shopper is never left with a dead button.
            btn.classList.remove('is-busy');
            btn.disabled = false;
            form.submit();
          });
      });
    });
  }

  /* --- boot --------------------------------------------------------------- */

  function boot() {
    initReveal();
    initAddToCart();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initHeader(); boot(); });
  } else {
    initHeader();
    boot();
  }

  // Theme editor swaps sections in and out without a page load.
  document.addEventListener('shopify:section:load', boot);
})();
